import { DismissibleBanner, useDismissibleBanner } from '../../../../hooks/useDismissibleBanner';

export const LOCAL_STORAGE_KEY_PREFIX = 'discoverability-status-banner-dismissed';

export function useDismissibleStatusBanner(prerenderUserId: number): DismissibleBanner {
  return useDismissibleBanner(LOCAL_STORAGE_KEY_PREFIX, prerenderUserId);
}
